import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=9520ab4a&scoped=true"
import script from "./Header.vue?vue&type=script&setup=true&lang=ts"
export * from "./Header.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=9520ab4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9520ab4a",
  null
  
)

export default component.exports